import {DarkTheme, LightTheme} from '@mercedes-benz/mui5-theme';
import {ThemeProvider} from '@mui/material';
import React, {createContext, useContext, useEffect, useState} from 'react';
import {AppConfig} from '../AppConfig';


const ThemeContext = createContext(null);


const themeList = [
  {
    id: 0,
    name: 'light',
    theme: LightTheme
  },
  {
    id: 1,
    name: 'dark',
    theme: DarkTheme
  },
];


const ThemeContextProvider = ({children}) =>
{

  const [activeThemeID, setActiveThemeID] = useState(() =>
  {
    const defaultTheme = AppConfig.defaultTheme;
    const theme_obj = themeList.find(o => o.theme === defaultTheme);
    return theme_obj.id;

  });
  const [activeTheme, setActiveTheme] = useState(AppConfig.defaultTheme);


  useEffect(() =>
  {
    const theme_obj = themeList.find(o => o.id === activeThemeID);
    console.log('theme switch to:', activeThemeID, theme_obj);
    debugger
    setActiveTheme(theme_obj.theme);

  }, [activeThemeID]);


  const contextValues = {activeThemeID, setActiveThemeID};

  return (
    <>
      <ThemeContext.Provider value={contextValues}>
        <ThemeProvider theme={activeTheme}>
          {children}
        </ThemeProvider>
      </ThemeContext.Provider>
    </>
  );
};

ThemeContextProvider.propTypes = {};

ThemeContextProvider.defaultProps = {};


const useMBUITheme = () =>
{
  const ctx = useContext(ThemeContext);
  if(ctx == null)
  {
    throw new Error('ThemeContext Provider missing');
  }

  return ctx;
};


export {ThemeContextProvider, useMBUITheme, themeList};
